<template>
  <div />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

defineOptions({ name: 'CapacityRiderCert' })

/** 旧书签：收编进「骑手管理 · 认证审核」 */
const router = useRouter()
onMounted(() => {
  router.replace({ path: '/distribution/platform/rider-mgmt', query: { tab: 'cert' } })
})
</script>
